export default __webpack_public_path__ + "static/media/project.71c85808.png";